/**
 * タッチデバイス判定
 */
function isTouch() {
    return !!('ontouchstart' in window || navigator.msMaxTouchPoints);
}

/**
 * スクロールバー幅の取得
 *
 * https://exiz.org/posts/javascript-scrollbar-width/
 */
function getScrollbarWidth() {
    let element = document.createElement('div');
    element.style.visibility = 'hidden';
    element.style.overflow = 'scroll';
    document.body.appendChild(element);
    const scrollbarWidth = element.offsetWidth - element.clientWidth;
    document.body.removeChild(element);

    return scrollbarWidth;
}

export const updateScrollbarWidth = () => {
    const root = document.documentElement;
    root.style.setProperty('--scrollbar-width', getScrollbarWidth() + "px");
}

export default {
    init: function () {
        document.body.classList.toggle('touch', isTouch());
        document.body.classList.toggle('no-touch', !isTouch());

        window.addEventListener('load', updateScrollbarWidth);
        setInterval(updateScrollbarWidth, 3000);
    },
    isTouch: isTouch,
};
